
<div class="container container-slim">
  <div class="text-center">
    <h2 class="headline">Informationen zur Accountlöschung</h2>
  </div>
  <div class="row">
    <div class="col-sm-12">

      <p>So löschst du deinen Leada-Account:</p>
      <ul>
        <li>Logge dich in der App mit deinen Zugangsdaten ein. Wenn du die App bereits deinstalliert hast, kannst du dich im Browser auf <a href="https://app.leada.de" target="_blank">https://app.leada.de</a> einloggen.</li>
        <li>Gehe auf das Menü (Icon oben rechts), gehe dann auf "Mein Account" und dann auf "Account löschen"</li>
        <li>Du wirst auf eine Webseite weitegeleitet, dort kannst du dann mit "Fortfahren" die Löschung deines Accounts bestätigen. Der Account wird dann direkt gelöscht.</li>
      </ul>

      <p>Solltest du deine Zugangsdaten nicht mehr besitzen so hinterlasse uns eine Nachricht unter <a href="https://www.leada.de/kontakt" target="_blank">https://www.leada.de/kontakt</a>; wir löschen deine Daten dann manuell.</p>
    </div>
  </div>
  <div class="row">
    <hr/>
  </div>
  <div class="text-center">
    <h2 class="headline">Information on account deletion</h2>
  </div>
  <div class="row">
    <p>How to delete your Leada account:</p>
    <ul>
      <li>Log in to the app with your access data. If you have already uninstalled the app, you can log in to <a href="https://app.leada.de" target="_blank">https://app.leada.de</a> in your browser.</li>
      <li>Go to the menu (icon top right), then go to "My account" and then to "Delete account"</li>
      <li>You will be redirected to a website where you can confirm the deletion of your account by clicking "Continue". The account will then be deleted immediately.</li>
    </ul>

    <p>If you no longer have your access data, please leave us a message at <a href="https://www.leada.de/kontakt" target="_blank">https://www.leada.de/kontakt</a>; we will then delete your data manually.</p>

  </div>
</div>
